<template>
  <screen
    class="preview-wrapper"
    v-show="show"
    :screen-info="$t('mobileScan.confirm_info')"
    :can-skip="false"
    @leave="$emit('leave')"
    center-titles
    purple-title
  >
    <gender-selector :showCaption="true" v-model="local.gender" class="pb-3" />
    <height-field class="height mb-3" v-model="local.height" />
    <weight-field class="height mb-3" v-model="local.weight" />
    <system-selector class="justify-end height mb-16" :onlyLength="true" />
    <c-button :confirmed-status="!!local && isValidated" class="tall:mt-10" @click="$emit('next')">
      <span>{{ $t('login.continue') }}</span>
    </c-button>
  </screen>
</template>

<script>
import { mapState } from 'vuex';
import ScanProcess from '@/modules/scan-process';
import Screen from '@/components/common/Screen.vue';
import HeightField from '@/components/common/Fields/Height.vue';
import WeightField from '@/components/common/Fields/Weight.vue';
import SystemSelector from '@/components/common/Fields/SystemSelector.vue';
import GenderSelector from '@/components/common/Fields/GenderSelector.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  components: {
    Screen,
    CButton,
    HeightField,
    WeightField,
    SystemSelector,
    GenderSelector,
  },
  props: {
    show: Boolean,
    profile: Object,
    height: Number,
  },
  data: () => ({
    local: {},
  }),
  mounted() {
    this.local = { ...this.me };
  },
  methods: {},
  computed: {
    ...mapState('user', ['me']),
    isValidated() {
      if (ScanProcess.provider === 10) {
        return (
          this.local.height >= 50 &&
          this.local.height <= 230 &&
          this.local.weight >= 1 &&
          this.local.gender !== null
        );
      }
      return true;
    },
    isEdited() {
      return (
        this.local.height !== this.me.height ||
        this.local.weight !== this.me.weight ||
        this.local.gender !== this.me.gender
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.height {
  width: 309px;
}

.preview-wrapper {
  ::v-deep .screen-titles {
    @apply mt-24;
  }
}
</style>
